const s = {
  name: "UserLock",
  dimensions: { width: 35, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 40" style="enable-background:new 0 0 35 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,0c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C26,3.6,22.4,0,18,0z M12,8c0-3.3,2.7-6,6-6
			s6,2.7,6,6s-2.7,6-6,6S12,11.3,12,8z"/>
		<path class="st0" d="M11,18C4.9,18,0,22.9,0,29v11h2V29c0-5,4-9,9-9h15v-2H11z"/>
		<path class="st0" d="M30,36c0.6,0,1-0.4,1-1s-0.4-1-1-1c-0.6,0-1,0.4-1,1S29.4,36,30,36z"/>
		<path class="st0" d="M33,30h2v10H25V30h2v-1c0-1.7,1.3-3,3-3c1.7,0,3,1.3,3,3V30z M27,32v6h6v-6H27z M31,30v-1c0-0.5-0.5-1-1-1
			c-0.5,0-1,0.5-1,1v1H31z"/>
		<path class="st0" d="M6,30v10h2V30H6z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserLock
};
